// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Other/Header/DownloadFile.css */

.download-page {
    display: flex;
    flex-direction: column;
    padding: 10px;
    margin: 0 auto;
    background-color: white;
    overflow-y: auto;
}

.download-heading {
    color: #EF6F53;
    text-align: center;
    font-size: 1.25rem;
    font-weight: bold;
    letter-spacing: 0.05rem;
    padding: 0.15rem;
    grid-column: 2;
    text-transform: uppercase;
}

.filters-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 1rem;
    width: 100%;
    padding: 0.25rem;
    background-color: #f8f9fa;
    border-radius: 8px;
}

.date-picker-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
    margin: 0;
    padding: 0;
}

.queue-select-wrapper,
.date-picker-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
    padding: 0;
    margin: 0;
}
.date-picker-wrapper{
    margin-left: 5rem;
    
}

.queue-select,
.datetime-input {
    padding: 0.25rem;
    border: 1px solid #ced4da;
    border-radius: 4px;
    font-size: 0.8rem;
}

label {
    font-weight: 500;
    color: #495057;
    font-size: 0.8rem;
    white-space: nowrap;
}

.search-container {
    margin: 0;
    padding: 0;
    width: 50%;
}

.search-input {
    width: 100%;
    padding: 2px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    transition: border-color 0.3s;
}

.search-input:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0,123,255,0.25);
}

.error-message {
    color: #dc3545;
    font-size: 0.875rem;
    margin: 10px 0;
    padding: 10px;
    background-color: #f8d7da;
    border: 1px solid #f5c6cb;
    border-radius: 4px;
    text-align: center;
    width: 100%;
}

.data-table-container {
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
    height:50vh;
    margin: auto;
    margin-top: 10px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.data-table {
    width: 100%;
    border-collapse: collapse;
    min-width: 600px;
    background: white;
}

.data-table th,
.data-table td {
    padding:5px;
    border: 1px solid #ddd;
    text-align: left;
    font-size: 0.75rem;
}

.data-table th {
    background: #f3f3f3;
    font-weight: bold;
    color: #4a7aad;
    font-weight: 600;
    white-space: nowrap;
    position: sticky;
    top: 0;
}

.data-table tr:nth-child(even) {
    background: #f9f9f9;
}

.data-table tr:hover {
    background: #f0f0f0;
}

.data-table tbody tr:hover {
    background-color: #f8f9fa;
}

.data-table td {
    color: #495057;
}

.loading-message {
    color: #666;
    text-align: center;
    margin: 2rem 0;
    font-weight: 500;
    padding: 20px;
    background: #f8f9fa;
    border-radius: 8px;
}

.no-data-message {
    text-align: center;
    padding: 0.5rem;
    color: #666;
    background: #f8f9fa;
    border-radius: 4px;
    width: 50%;
    margin: auto;
    text-transform: uppercase;
}

.table-info {
    margin-top: 2px;
    color: #4a7aad;
    font-size: 14px;
    font-weight: 600;
}

.download-btn {
    background-color: #007bff;
    color: white;
    padding: 2px;
    font-size: 1rem;
    font-weight: 600;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;
    width: 15%;
    margin: auto;
    margin-top: 5px;
}

.download-btn:hover:not(:disabled) {
    background-color: #0056b3;
}

.download-btn:disabled {
    background-color: #ccc;
    cursor: not-allowed;
    opacity: 0.7;
}`, "",{"version":3,"sources":["webpack://./src/components/routes/Other/Header/Download/DownloadFile.css"],"names":[],"mappings":"AAAA,wDAAwD;;AAExD;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,cAAc;IACd,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,SAAS;IACT,UAAU;AACd;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,UAAU;IACV,SAAS;AACb;AACA;IACI,iBAAiB;;AAErB;;AAEA;;IAEI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,0CAA0C;AAC9C;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;;IAEI,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,MAAM;AACV;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,UAAU;IACV,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;AAChB","sourcesContent":["/* src/components/routes/Other/Header/DownloadFile.css */\n\n.download-page {\n    display: flex;\n    flex-direction: column;\n    padding: 10px;\n    margin: 0 auto;\n    background-color: white;\n    overflow-y: auto;\n}\n\n.download-heading {\n    color: #EF6F53;\n    text-align: center;\n    font-size: 1.25rem;\n    font-weight: bold;\n    letter-spacing: 0.05rem;\n    padding: 0.15rem;\n    grid-column: 2;\n    text-transform: uppercase;\n}\n\n.filters-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 0.5rem;\n    margin-bottom: 1rem;\n    width: 100%;\n    padding: 0.25rem;\n    background-color: #f8f9fa;\n    border-radius: 8px;\n}\n\n.date-picker-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 0.5rem;\n    margin: 0;\n    padding: 0;\n}\n\n.queue-select-wrapper,\n.date-picker-wrapper {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0;\n    margin: 0;\n}\n.date-picker-wrapper{\n    margin-left: 5rem;\n    \n}\n\n.queue-select,\n.datetime-input {\n    padding: 0.25rem;\n    border: 1px solid #ced4da;\n    border-radius: 4px;\n    font-size: 0.8rem;\n}\n\nlabel {\n    font-weight: 500;\n    color: #495057;\n    font-size: 0.8rem;\n    white-space: nowrap;\n}\n\n.search-container {\n    margin: 0;\n    padding: 0;\n    width: 50%;\n}\n\n.search-input {\n    width: 100%;\n    padding: 2px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 14px;\n    transition: border-color 0.3s;\n}\n\n.search-input:focus {\n    outline: none;\n    border-color: #007bff;\n    box-shadow: 0 0 0 2px rgba(0,123,255,0.25);\n}\n\n.error-message {\n    color: #dc3545;\n    font-size: 0.875rem;\n    margin: 10px 0;\n    padding: 10px;\n    background-color: #f8d7da;\n    border: 1px solid #f5c6cb;\n    border-radius: 4px;\n    text-align: center;\n    width: 100%;\n}\n\n.data-table-container {\n    width: 100%;\n    max-width: 100%;\n    overflow-x: auto;\n    height:50vh;\n    margin: auto;\n    margin-top: 10px;\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.data-table {\n    width: 100%;\n    border-collapse: collapse;\n    min-width: 600px;\n    background: white;\n}\n\n.data-table th,\n.data-table td {\n    padding:5px;\n    border: 1px solid #ddd;\n    text-align: left;\n    font-size: 0.75rem;\n}\n\n.data-table th {\n    background: #f3f3f3;\n    font-weight: bold;\n    color: #4a7aad;\n    font-weight: 600;\n    white-space: nowrap;\n    position: sticky;\n    top: 0;\n}\n\n.data-table tr:nth-child(even) {\n    background: #f9f9f9;\n}\n\n.data-table tr:hover {\n    background: #f0f0f0;\n}\n\n.data-table tbody tr:hover {\n    background-color: #f8f9fa;\n}\n\n.data-table td {\n    color: #495057;\n}\n\n.loading-message {\n    color: #666;\n    text-align: center;\n    margin: 2rem 0;\n    font-weight: 500;\n    padding: 20px;\n    background: #f8f9fa;\n    border-radius: 8px;\n}\n\n.no-data-message {\n    text-align: center;\n    padding: 0.5rem;\n    color: #666;\n    background: #f8f9fa;\n    border-radius: 4px;\n    width: 50%;\n    margin: auto;\n    text-transform: uppercase;\n}\n\n.table-info {\n    margin-top: 2px;\n    color: #4a7aad;\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.download-btn {\n    background-color: #007bff;\n    color: white;\n    padding: 2px;\n    font-size: 1rem;\n    font-weight: 600;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    width: 15%;\n    margin: auto;\n    margin-top: 5px;\n}\n\n.download-btn:hover:not(:disabled) {\n    background-color: #0056b3;\n}\n\n.download-btn:disabled {\n    background-color: #ccc;\n    cursor: not-allowed;\n    opacity: 0.7;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
